import { useCallback } from "react";
import { getPricePath } from "@danishagro/shared/src/helpers/getPricePath.helper";
import { DA_ProductPrice } from "@danishagro/shared/src/interfaces/price.interface";
import { useAppData } from "../contexts/appData.context";
import { useRequest } from "./useRequest.hook";

export const useVariantPrices = () => {
    const { customerNumber } = useAppData();
    const request = useRequest();

    const getProductVariantPrice = useCallback(
        (
            productNumber: string,
            variantId: string | null | undefined,
            variantSelected?: boolean,
            options?
        ) => {
            return request
                .post(
                    getPricePath(customerNumber, variantSelected),
                    [
                        {
                            productNumber,
                            variantId: variantId ?? undefined,
                        },
                    ],
                    options
                )
                .then((response) => response.json())
                .then(({ productPrices }) => {
                    const [price] = productPrices;
                    return price as DA_ProductPrice;
                });
        },
        [customerNumber, request]
    );

    return {
        getProductVariantPrice,
    };
};
